import type { OrganizationsTranslations } from "../interfaces/organizations";

export const organizationsTranslations: OrganizationsTranslations = {
  page_title: "Organizaciones",
  page_subtitle: "Busca una organización y abre su panel para decidir qué funcionalidades ven sus miembros",
  action_refresh: "Actualizar la lista",
  action_retry: "Reintentar",
  action_clear_filters: "Quitar filtros",
  error_load: "No pudimos cargar las organizaciones.",

  filter_search_label: "Buscar",
  filter_search_placeholder: "Nombre, correo, ID o usuario…",
  filter_search_min_length: "Escribe al menos {{count}} caracteres para buscar.",
  filter_status_label: "Estado",
  filter_status_all: "Todos los estados",
  filter_payout_batches_label: "Pagos por lote",
  filter_payout_batches_all: "Todas",
  filter_payout_batches_enabled: "Habilitadas",
  filter_payout_batches_disabled: "Sin habilitar",

  col_name: "Organización",
  col_country: "País",
  col_status: "Estado",
  col_created: "Creada",
  col_payout_batches: "Pagos por lote",
  value_none: "—",

  status_active: "Activa",
  status_inactive: "Inactiva",
  status_suspended: "Suspendida",
  status_pending: "Pendiente",

  payout_batches_switch_aria: "Pagos por lote para {{name}}",

  empty_title: "Aún no hay organizaciones",
  empty_description: "Las organizaciones cliente aparecerán aquí cuando se registren.",
  empty_filtered_title: "Ninguna organización coincide",
  empty_filtered_description: "Prueba con otro término o quita los filtros.",

  disable_dialog_title: "¿Quitar pagos por lote a {{name}}?",
  disable_dialog_description:
    "Sus miembros dejarán de ver el módulo y no podrán subir, revisar ni aprobar lotes. Los lotes que ya se están pagando terminan con normalidad, y el equipo Coloca los sigue viendo.",
  disable_dialog_confirm: "Quitar acceso",
  disable_dialog_cancel: "Cancelar",

  toast_payout_batches_enabled: "Pagos por lote habilitado para {{name}}",
  toast_payout_batches_disabled: "Pagos por lote deshabilitado para {{name}}",
  col_breb_key: "Llave Bre-B",
  breb_key_switch_aria: "Llave Bre-B para {{name}}",
  toast_breb_key_enabled: "Llave Bre-B habilitada para {{name}}",
  toast_breb_key_disabled: "Llave Bre-B deshabilitada para {{name}}. Si ya tenía una, la conserva.",
  rollout_body_on: "Prendida para todas las organizaciones verificadas, sin importar su interruptor propio.",
  rollout_body_off: "Cada una decide: solo la tienen las organizaciones que habilites una por una.",
  rollout_switch_aria: "Llave Bre-B para todas las organizaciones",
  rollout_confirm_on_title: "¿Prender la llave Bre-B para todas las organizaciones?",
  rollout_confirm_on_body: "Cualquier organización verificada podrá crear su llave desde el dashboard.",
  rollout_confirm_on_cta: "Prender para todas",
  rollout_confirm_off_body:
    "Solo las organizaciones habilitadas una por una podrán crear una llave. Las llaves que ya existen siguen funcionando.",
  rollout_cancel: "Cancelar",
  toast_rollout_on: "Llave Bre-B prendida para todas las organizaciones",
  toast_rollout_failed: "No pudimos cambiar el interruptor general. Intenta de nuevo.",
  rollout_mode_per_organization: "Cada una decide",
  rollout_mode_on_for_all: "Todas",
  rollout_mode_off_for_all: "Ninguna",
  rollout_body_off_for_all:
    "Apagada para todas: ninguna organización la tiene, tampoco las que tienen su interruptor prendido. Ese interruptor se conserva y vuelve a contar cuando quites el bloqueo.",
  rollout_confirm_per_organization_title: "¿Que cada organización decida sobre {{feature}}?",
  rollout_confirm_per_organization_cta: "Que cada una decida",
  rollout_confirm_off_for_all_title: "¿Apagar {{feature}} para todas las organizaciones?",
  rollout_confirm_off_for_all_cta: "Apagar para todas",
  rollout_confirm_off_for_all_keeps:
    "El interruptor de cada organización no se toca: cuando vuelvas a «Cada una decide», cada una queda como estaba.",
  rollout_confirm_unblock_body:
    "Vuelven a tenerla solo las organizaciones con su interruptor prendido, tal como estaban antes del bloqueo.",
  payout_batches_rollout_confirm_block_body:
    "Los miembros de ninguna organización verán el módulo, tampoco los de las habilitadas. Los lotes que ya se están pagando terminan con normalidad y el equipo de Coloca sigue entrando.",
  rollout_confirm_block_body:
    "Ninguna organización podrá crear una llave nueva. Las llaves que ya existen siguen recibiendo pagos.",
  crypto_rollout_confirm_block_body:
    "Ninguna organización podrá comprar ni vender USDT, ni cargar tarjetas con pesos, que compra USDT. Las operaciones en curso terminan con normalidad.",
  card_deposits_rollout_confirm_block_body:
    "Ninguna tarjeta cripto mostrará su QR de depósito. Los depósitos que lleguen a direcciones ya compartidas se siguen registrando.",
  card_cop_top_ups_rollout_confirm_block_body:
    "Ninguna organización podrá cargar sus tarjetas con pesos. Las recargas en curso terminan normalmente.",
  breb_qr_payments_rollout_confirm_block_body:
    "Ninguna organización podrá pagar QR Bre-B. Los pagos ya enviados siguen su curso.",
  toast_rollout_per_organization: "{{feature}}: ahora decide cada organización",
  toast_rollout_off_for_all: "{{feature}}: apagada para todas las organizaciones",
  features_off_for_all: "Apagadas para todas: {{features}}",
  feature_blocked_note_on:
    "Apagada para todas desde la configuración general. Su interruptor está prendido y vuelve a contar al quitar el bloqueo.",
  feature_blocked_note_off: "Apagada para todas desde la configuración general.",
  toast_update_failed: "No pudimos actualizar {{name}}. Vuelve a intentarlo.",
  col_crypto: "Cripto",
  crypto_switch_aria: "Cripto para {{name}}",
  toast_crypto_enabled: "Cripto habilitado para {{name}}",
  toast_crypto_disabled:
    "Cripto deshabilitado para {{name}}. Sus operaciones en curso terminan con normalidad.",
  crypto_rollout_body_on: "Prendido para todas las organizaciones, sin importar su interruptor propio.",
  crypto_rollout_body_off: "Cada una decide: solo lo tienen las organizaciones que habilites una por una.",
  crypto_rollout_switch_aria: "Cripto para todas las organizaciones",
  crypto_rollout_confirm_on_title: "¿Prender Cripto para todas las organizaciones?",
  crypto_rollout_confirm_on_body: "Cualquier organización podrá comprar y vender USDT desde el dashboard.",
  crypto_rollout_confirm_off_body:
    "Solo las organizaciones habilitadas una por una podrán comprar y vender USDT. Las operaciones en curso terminan con normalidad.",
  toast_crypto_rollout_on: "Cripto prendido para todas las organizaciones",
  col_card_deposits: "QR de stablecoins",
  card_deposits_switch_aria: "QR de depósito de stablecoins para {{name}}",
  toast_card_deposits_enabled: "QR de depósito de stablecoins visible en las tarjetas de {{name}}",
  toast_card_deposits_disabled:
    "QR de depósito de stablecoins oculto para {{name}}. Los depósitos que lleguen igual se registran.",
  card_deposits_rollout_body_on:
    "Prendido: todas las tarjetas cripto muestran su QR, sin importar el interruptor de su organización.",
  card_deposits_rollout_body_off:
    "Cada una decide: solo lo muestran las tarjetas de las organizaciones que habilites una por una.",
  card_deposits_rollout_switch_aria: "QR de depósito de stablecoins para todas las organizaciones",
  card_deposits_rollout_confirm_on_title: "¿Mostrar el QR de depósito en todas las tarjetas cripto?",
  card_deposits_rollout_confirm_on_body:
    "Todas las organizaciones verán la dirección de depósito de sus tarjetas cripto y podrán recargarlas enviando USDT o USDC por Polygon.",
  card_deposits_rollout_confirm_off_body:
    "Solo las organizaciones habilitadas una por una verán el QR. Los depósitos que lleguen a direcciones ya compartidas se siguen registrando.",
  toast_card_deposits_rollout_on: "QR de depósito de stablecoins visible para todas las organizaciones",
  col_card_cop_top_ups: "Pesos → tarjeta",
  card_cop_top_ups_switch_aria: "Cargar tarjetas con pesos para {{name}}",
  toast_card_cop_top_ups_enabled: "{{name}} ya puede cargar sus tarjetas cripto con su saldo en pesos",
  toast_card_cop_top_ups_disabled:
    "Carga de tarjetas con pesos apagada para {{name}}. Las recargas en curso terminan normalmente.",
  card_cop_top_ups_rollout_body_on:
    "Prendido: todas las organizaciones pueden cargar sus tarjetas cripto con su saldo en pesos, sin importar el interruptor de cada una.",
  card_cop_top_ups_rollout_body_off:
    "Cada una decide: solo lo tienen las organizaciones que habilites una por una. Es independiente del QR de stablecoins.",
  card_cop_top_ups_rollout_switch_aria: "Cargar tarjetas con pesos para todas las organizaciones",
  card_cop_top_ups_rollout_confirm_on_title: "¿Habilitar la carga de tarjetas con pesos para todas?",
  card_cop_top_ups_rollout_confirm_on_body:
    "Todas las organizaciones verán «Saldo en pesos» al cargar sus tarjetas cripto: compramos USDT con sus pesos y los enviamos a la tarjeta.",
  card_cop_top_ups_rollout_confirm_off_body:
    "Solo las organizaciones habilitadas una por una la seguirán viendo. Las recargas ya hechas terminan normalmente.",
  toast_card_cop_top_ups_rollout_on: "Carga de tarjetas con pesos habilitada para todas las organizaciones",
  custom_key_action: "Asignar llave personalizada",
  custom_key_action_aria: "Asignar llave Bre-B personalizada a {{name}}",
  custom_key_title: "Llave personalizada para {{name}}",
  custom_key_description:
    "Una llave a la medida, en lugar de las que se arman con los datos de la organización. Solo las personas autorizadas ven esta opción.",
  custom_key_input_label: "Llave",
  custom_key_input_placeholder: "tuempresa",
  custom_key_format_hint: "De 5 a 20 letras o números, sin espacios, tildes ni símbolos.",
  custom_key_invalid: "Usa de 5 a 20 letras o números, sin espacios, tildes ni símbolos.",
  custom_key_checking: "Verificando…",
  custom_key_available: "Disponible",
  custom_key_taken_coloca: "Ocupada por una cuenta de Coloca",
  custom_key_taken_elsewhere: "Registrada en otra entidad Bre-B",
  custom_key_unknown: "No pudimos verificarla",
  custom_key_check_again: "Verificar de nuevo",
  custom_key_preview_label: "Así la verá quien pague",
  custom_key_rollout_note:
    "No hace falta tener la llave Bre-B habilitada. Después, la organización la usa y puede eliminarla como cualquier otra.",
  custom_key_keys_title: "Llaves de {{name}}",
  custom_key_assign_another: "Asignar otra llave personalizada",
  custom_key_not_verified:
    "La organización no tiene su verificación aprobada, así que todavía no se le puede asignar una llave.",
  custom_key_rail_disabled: "Los recaudos Bre-B están apagados para esta organización.",
  custom_key_load_error: "No pudimos leer la llave de la organización.",
  custom_key_retry: "Reintentar",
  custom_key_assign: "Asignar llave",
  custom_key_cancel: "Cancelar",
  custom_key_two_factor_required: "Activa la autenticación en dos pasos para asignar llaves.",
  custom_key_two_factor_description:
    "Escribe el código de tu app de autenticación para asignar {{key}} a {{name}}.",
  custom_key_assigned_toast: "Asignaste la llave {{key}} a {{name}}.",
  custom_key_assigned_pending_toast: "Asignaste la llave {{key}} a {{name}}. Se activa en unos segundos.",
  custom_key_transfer_action: "Transferir a otra organización",
  custom_key_transfer_action_aria: "Transferir la llave {{key}} a otra organización",
  custom_key_transfer_title: "Transferir {{key}}",
  custom_key_transfer_description:
    "La llave pasa a otra organización sin borrarse de Bre-B, así nadie puede quedársela en el camino.",
  custom_key_transfer_picker_label: "Organización que la recibe",
  custom_key_transfer_picker_required_hint: "Elige la organización que se queda con la llave.",
  custom_key_transfer_picker_org_hint: "Abajo ves qué cambia en cada organización.",
  custom_key_transfer_same_org: "Esa organización ya tiene la llave. Elige otra.",
  custom_key_transfer_loading: "Revisando qué cambia…",
  custom_key_transfer_side_from: "Desde",
  custom_key_transfer_side_to: "Hacia",
  custom_key_transfer_primary: "Llave principal",
  custom_key_transfer_primary_shared: "La general de Coloca",
  custom_key_transfer_primary_changes: "Cambia",
  custom_key_transfer_primary_same: "Sin cambios",
  custom_key_transfer_primary_this: "Pasa a ser esta",
  custom_key_transfer_arrives_as: "En {{name}} queda como llave de tipo {{source}}.",
  custom_key_transfer_static_qr:
    "El QR sin monto se va con la llave: lo que se pague por él le llega a {{name}}.",
  custom_key_transfer_live_qrs:
    "{{name}} tiene {{count}} cobro(s) con QR vigente(s) sobre esta llave. Si los pagan, el dinero le llega a {{name}}; vencen en máximo 60 minutos.",
  custom_key_transfer_in_flight:
    "Un pago que llegue justo en el minuto del cambio queda retenido para conciliarlo a mano.",
  custom_key_transfer_otc_title: "{{name}} tiene operaciones de USDT en curso con esta llave",
  custom_key_transfer_otc_sales: "{{count}} venta(s) todavía pueden pagar sus pesos a esta llave.",
  custom_key_transfer_otc_purchases: "{{count}} compra(s) se reembolsarían a esta llave si fallan.",
  custom_key_transfer_otc_wait: "Podrás moverla cuando terminen.",
  custom_key_transfer_problem_title: "{{name}} todavía no puede recibir la llave",
  custom_key_transfer_problem_verification_required:
    "No tiene su verificación aprobada. Cuando la aprueben podrás transferirle la llave.",
  custom_key_transfer_problem_rail_disabled:
    "Tiene los recaudos Bre-B apagados, así que no puede recibir la llave.",
  custom_key_transfer_problem_no_pricing:
    "No tiene una ruta o una comisión de recaudos Bre-B configurada, así que no se le pueden fijar los montos de la llave.",
  custom_key_transfer_submit: "Transferir llave",
  custom_key_transfer_two_factor_required: "Activa la autenticación en dos pasos para transferir llaves.",
  custom_key_transfer_two_factor_description:
    "Escribe el código de tu app de autenticación para transferir {{key}} a {{name}}.",
  custom_key_transferred_toast: "Transferiste la llave {{key}} a {{name}}.",
  col_features: "Funcionalidades",
  features_none: "Ninguna",
  features_only_global: "Solo las generales",
  features_for_all: "Prendidas para todas: {{features}}",
  action_change: "Cambiar",
  action_configure: "Configurar",
  configure_aria: "Configurar {{name}}",
  action_global_settings: "Configuración general",
  detail_id: "ID",
  copy_id_aria: "Copiar el ID",
  id_copied: "ID copiado",
  features_title: "Funcionalidades",
  features_hint: "Los cambios se guardan al instante.",
  features_read_only: "Solo lectura: no tienes permiso para editar organizaciones.",
  feature_global_note: "Prendida para todas desde la configuración general.",
  feature_payout_batches_description:
    "Sus miembros suben un archivo y pagan a muchos beneficiarios en una sola operación, con la aprobación de una segunda persona.",
  feature_breb_key_description:
    "Puede crear su propia llave Bre-B para recibir transferencias y su QR para cualquier monto.",
  feature_crypto_description:
    "Puede comprar USDT con el saldo de su billetera en pesos y venderlos para recibir pesos.",
  feature_card_deposits_description:
    "Sus tarjetas cripto muestran la dirección de depósito (QR) para recargarlas con USDT o USDC.",
  feature_card_cop_top_ups_description:
    "Sus tarjetas cripto se pueden cargar con el saldo en pesos: compramos USDT y los enviamos a la tarjeta.",
  global_settings_title: "Configuración general",
  global_settings_description:
    "Cada funcionalidad puede quedar en manos de cada organización, prendida para todas o apagada para todas. Mientras esté prendida o apagada para todas, el interruptor de cada organización no cuenta, pero se conserva.",
  global_settings_load_error: "No pudimos leer la configuración general.",
  payout_batches_rollout_body_on:
    "Prendido para todas las organizaciones, sin importar su interruptor propio.",
  payout_batches_rollout_body_off:
    "Cada una decide: solo lo tienen las organizaciones que habilites una por una.",
  payout_batches_rollout_switch_aria: "Pagos por lote para todas las organizaciones",
  payout_batches_rollout_confirm_on_title: "¿Prender pagos por lote para todas las organizaciones?",
  payout_batches_rollout_confirm_on_body:
    "Los miembros de cualquier organización podrán subir, revisar y aprobar lotes desde el dashboard.",
  payout_batches_rollout_confirm_off_body:
    "Solo las organizaciones habilitadas una por una seguirán viendo el módulo. Los lotes que ya se están pagando terminan con normalidad.",
  toast_payout_batches_rollout_on: "Pagos por lote prendido para todas las organizaciones",
  col_breb_qr_payments: "Pagar con QR",
  feature_breb_qr_payments_description:
    "Puede pagar códigos QR Bre-B de comercios y personas con el saldo de su billetera en pesos.",
  breb_qr_payments_switch_aria: "Pagar con QR para {{name}}",
  toast_breb_qr_payments_enabled: "{{name}} ya puede pagar con QR",
  toast_breb_qr_payments_disabled:
    "Pagar con QR apagado para {{name}}. Los pagos ya enviados siguen su curso.",
  breb_qr_payments_rollout_body_on:
    "Prendido: todas las organizaciones pueden pagar QR, sin importar el interruptor de cada una.",
  breb_qr_payments_rollout_body_off:
    "Cada una decide: solo pagan QR las organizaciones que habilites una por una.",
  breb_qr_payments_rollout_switch_aria: "Pagar con QR para todas las organizaciones",
  breb_qr_payments_rollout_confirm_on_title: "¿Prender pagar con QR para todas las organizaciones?",
  breb_qr_payments_rollout_confirm_on_body:
    "Todas las organizaciones podrán escanear y pagar códigos QR Bre-B desde su billetera en pesos.",
  breb_qr_payments_rollout_confirm_off_body:
    "Solo las organizaciones habilitadas una por una podrán pagar QR. Los pagos ya enviados siguen su curso.",
  toast_breb_qr_payments_rollout_on: "Pagar con QR prendido para todas las organizaciones",

  matched_user: "Usuario: {{name}} · {{email}}",
  matched_users_more: "+{{count}}",

  tab_overview: "Resumen",
  tab_users: "Usuarios",
  tab_features: "Funcionalidades",
  overview_load_error: "No pudimos cargar el resumen de esta organización.",
  overview_forbidden: "Tu rol no tiene los permisos de lectura para ver el resumen de organizaciones.",

  overview_status_title: "Estado",
  overview_verification_label: "Verificación",
  overview_purpose_kyc: "KYC",
  overview_purpose_kyb: "KYB",
  identity_type_business: "Empresa",
  identity_type_individual: "Persona",
  overview_verification_none: "No tiene identidad propia: aún no empieza su verificación.",
  overview_verification_verified_at: "Aprobada el {{date}}.",
  overview_verification_in_review: "La estamos revisando.",
  overview_verification_pending: "Todavía no termina de enviar sus datos.",
  overview_verification_expired: "Venció: tiene que verificarse de nuevo.",
  overview_cards_label: "Tarjetas",
  overview_cards_provider_label: "Tarjetas · {{provider}}",
  overview_cards_no_provider: "No tiene proveedor de tarjetas asignado.",
  overview_cards_own_none: "Sin registro propio",
  overview_cards_paused: "Pausado: {{reason}}",
  overview_cards_holders_label: "Titulares",
  overview_cards_holders_none: "Aún no tiene titulares registrados.",
  overview_access_label: "Acceso",
  overview_access_active: "Activos: {{count}}",
  overview_access_none: "No tiene usuarios: nadie puede entrar al dashboard.",
  overview_access_last_login: "Último ingreso {{when}}, {{name}}.",
  overview_access_never: "Ningún usuario ha ingresado todavía.",
  provider_crypto: "Coloca Crypto",
  provider_cards: "Coloca Cards",

  stage_not_registered: "Sin registrar",
  stage_in_progress: "En proceso",
  stage_paused: "Pausado",
  stage_in_review: "En revisión",
  stage_enabled: "Habilitado",
  stage_rejected: "Rechazado",
  holders_not_registered: "sin registrar",
  holders_in_progress: "en proceso",
  holders_paused: "pausados",
  holders_in_review: "en revisión",
  holders_enabled: "habilitados",
  holders_rejected: "rechazados",
  pause_reason_business_identity: "es una empresa, y solo las personas pueden ser titulares",
  pause_reason_missing_identity_fields: "le falta el apellido o la fecha de nacimiento",
  pause_reason_missing_email: "le falta un correo de contacto",
  pause_reason_missing_address: "le falta la dirección de residencia",
  pause_reason_unmappable_state: "no reconocemos el estado o departamento de su dirección",
  pause_reason_missing_client_data: "faltan datos del titular",
  pause_reason_documents_unavailable: "no pudimos traer sus documentos de la verificación",
  pause_reason_already_registered: "la persona ya está registrada con otra identidad",
  pause_reason_other: "otro motivo; revisa las alertas del equipo",

  overview_details_title: "Datos",
  detail_phone: "Teléfono",
  detail_created_by: "por {{name}}",

  overview_activity_title: "Actividad",
  activity_wallets: "Billeteras",
  activity_wallets_none: "No tiene billeteras activadas.",
  wallet_frozen: "congelada",
  wallet_closed: "cerrada",
  activity_last_payin: "Último cobro",
  activity_last_payout: "Último envío",
  activity_last_value: "{{when}} · {{count}} en 30 días",
  activity_never: "Nunca",
  activity_cards: "Tarjetas",
  activity_cards_value: "{{total}} · activas {{active}} · congeladas {{frozen}}",
  activity_holders: "Titulares",
  activity_breb_keys: "Llaves Bre-B",
  activity_api_keys: "API keys",
  activity_api_keys_value: "Activas: {{count}}",
  activity_api_keys_used: "Activas: {{count}} · usada {{when}}",
  activity_none: "Ninguna",

  member_status_active: "Activo",
  member_status_pending_verification: "Sin verificar",
  member_status_inactive: "Desactivado",
  member_status_suspended: "Suspendido",
  members_active: "Activos",
  members_pending_verification: "Sin verificar",
  members_inactive: "Desactivados",
  members_suspended: "Suspendidos",
  users_empty_title: "No tiene usuarios",
  users_empty_description: "Nadie de esta organización puede entrar al dashboard.",
  user_last_login: "Ingresó {{when}}",
  user_never_logged_in: "Nunca ha ingresado",
  user_two_factor: "Tiene 2FA activo",
  copy_email_aria: "Copiar el correo de {{name}}",
  email_copied: "Correo copiado",
  users_truncated: "Se muestran los primeros {{count}}.",
  col_card_wallet: "Wallet de tarjetas",
  card_wallet_switch_aria: "Wallet de tarjetas para {{name}}",
  toast_card_wallet_enabled: "{{name}} ya tiene la wallet de tarjetas: puede retirar saldo de sus tarjetas",
  toast_card_wallet_disabled:
    "Wallet de tarjetas apagada para {{name}}. Sus tarjetas se cargan con pesos o cripto y su saldo solo se mueve entre tarjetas.",
  feature_card_wallet_description:
    "Un saldo en dólares para cargar sus tarjetas al instante y retirar saldo de ellas. Sin ella, las tarjetas cripto se cargan con pesos o cripto y su saldo solo se mueve entre tarjetas.",
  col_card_design: "Personalizar tarjeta",
  card_design_switch_aria: "Personalizar tarjeta para {{name}}",
  toast_card_design_enabled:
    "{{name}} ya puede personalizar sus tarjetas: su diseño se ve en la vista segura de la tarjeta",
  toast_card_design_disabled:
    "Personalización apagada para {{name}}. Sus tarjetas vuelven al diseño Coloca; su diseño queda guardado.",
  feature_card_design_description:
    "Colores y logo propios, junto a la marca Coloca, en la vista segura de la tarjeta que muestra por API. No cambia la tarjeta en Apple Pay ni Google Pay.",
};
